import { render, staticRenderFns } from "./FormStartupRegistrationAdmin.vue?vue&type=template&id=3d0a268d"
import script from "./FormStartupRegistrationAdmin.vue?vue&type=script&lang=js"
export * from "./FormStartupRegistrationAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports